var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9158_13463)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9158_13463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9158_13463)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9158_13463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9158_13463)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9158_13463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9158_13463)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9158_13463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9158_13463)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9158_13463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9158_13463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "#CurrentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3855 6.90865H8.92398C8.76077 6.90865 8.60424 6.83202 8.48884 6.69563C8.37343 6.55924 8.30859 6.37426 8.30859 6.18137C8.30859 5.98849 8.37343 5.80351 8.48884 5.66711C8.60424 5.53072 8.76077 5.4541 8.92398 5.4541H19.3855C19.5487 5.4541 19.7053 5.53072 19.8207 5.66711C19.9361 5.80351 20.0009 5.98849 20.0009 6.18137C20.0009 6.37426 19.9361 6.55924 19.8207 6.69563C19.7053 6.83202 19.5487 6.90865 19.3855 6.90865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46154 6.90865H4.61538C4.45217 6.90865 4.29565 6.83202 4.18024 6.69563C4.06483 6.55924 4 6.37426 4 6.18137C4 5.98849 4.06483 5.80351 4.18024 5.66711C4.29565 5.53072 4.45217 5.4541 4.61538 5.4541H6.46154C6.62475 5.4541 6.78127 5.53072 6.89668 5.66711C7.01209 5.80351 7.07692 5.98849 7.07692 6.18137C7.07692 6.37426 7.01209 6.55924 6.89668 6.69563C6.78127 6.83202 6.62475 6.90865 6.46154 6.90865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0769 12.727H4.61538C4.45217 12.727 4.29565 12.6504 4.18024 12.514C4.06483 12.3776 4 12.1926 4 11.9997C4 11.8068 4.06483 11.6219 4.18024 11.4855C4.29565 11.3491 4.45217 11.2725 4.61538 11.2725H15.0769C15.2401 11.2725 15.3967 11.3491 15.5121 11.4855C15.6275 11.6219 15.6923 11.8068 15.6923 11.9997C15.6923 12.1926 15.6275 12.3776 15.5121 12.514C15.3967 12.6504 15.2401 12.727 15.0769 12.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92308 18.5454H4.61538C4.45217 18.5454 4.29565 18.4687 4.18024 18.3324C4.06483 18.196 4 18.011 4 17.8181C4 17.6252 4.06483 17.4402 4.18024 17.3038C4.29565 17.1674 4.45217 17.0908 4.61538 17.0908H8.92308C9.08629 17.0908 9.24281 17.1674 9.35822 17.3038C9.47363 17.4402 9.53846 17.6252 9.53846 17.8181C9.53846 18.011 9.47363 18.196 9.35822 18.3324C9.24281 18.4687 9.08629 18.5454 8.92308 18.5454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69186 8.36364C7.32672 8.36364 6.96979 8.23568 6.66619 7.99593C6.36259 7.75619 6.12597 7.41544 5.98623 7.01676C5.8465 6.61809 5.80994 6.1794 5.88118 5.75617C5.95241 5.33294 6.12824 4.94417 6.38643 4.63904C6.64462 4.33391 6.97357 4.12611 7.33169 4.04192C7.68981 3.95774 8.06101 4.00095 8.39835 4.16608C8.73569 4.33122 9.02402 4.61087 9.22688 4.96967C9.42974 5.32846 9.53801 5.7503 9.53801 6.18182C9.53801 6.76047 9.34351 7.31543 8.99729 7.7246C8.65106 8.13377 8.18149 8.36364 7.69186 8.36364ZM7.69186 5.45455C7.57015 5.45455 7.45117 5.4972 7.34997 5.57711C7.24877 5.65703 7.16989 5.77061 7.12332 5.9035C7.07674 6.0364 7.06455 6.18263 7.0883 6.3237C7.11204 6.46478 7.17065 6.59437 7.25672 6.69608C7.34278 6.79779 7.45243 6.86706 7.5718 6.89512C7.69117 6.92318 7.81491 6.90878 7.92736 6.85373C8.0398 6.79869 8.13591 6.70547 8.20353 6.58587C8.27115 6.46627 8.30724 6.32566 8.30724 6.18182C8.30724 5.98893 8.24241 5.80395 8.127 5.66756C8.01159 5.53117 7.85507 5.45455 7.69186 5.45455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3071 14.182C15.942 14.182 15.585 14.054 15.2814 13.8143C14.9778 13.5746 14.7412 13.2338 14.6015 12.8351C14.4617 12.4364 14.4252 11.9978 14.4964 11.5745C14.5676 11.1513 14.7435 10.7625 15.0017 10.4574C15.2599 10.1523 15.5888 9.94447 15.9469 9.86028C16.305 9.7761 16.6762 9.8193 17.0136 9.98444C17.3509 10.1496 17.6393 10.4292 17.8421 10.788C18.045 11.1468 18.1532 11.5687 18.1532 12.0002C18.1532 12.5788 17.9587 13.1338 17.6125 13.543C17.2663 13.9521 16.7967 14.182 16.3071 14.182ZM16.3071 11.2729C16.1854 11.2729 16.0664 11.3156 15.9652 11.3955C15.864 11.4754 15.7851 11.589 15.7386 11.7219C15.692 11.8548 15.6798 12.001 15.7035 12.1421C15.7273 12.2831 15.7859 12.4127 15.8719 12.5144C15.958 12.6161 16.0677 12.6854 16.187 12.7135C16.3064 12.7415 16.4301 12.7271 16.5426 12.6721C16.655 12.617 16.7511 12.5238 16.8188 12.4042C16.8864 12.2846 16.9225 12.144 16.9225 12.0002C16.9225 11.8073 16.8576 11.6223 16.7422 11.4859C16.6268 11.3495 16.4703 11.2729 16.3071 11.2729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1547 20.0004C9.78961 20.0004 9.43268 19.8724 9.12908 19.6327C8.82548 19.3929 8.58886 19.0522 8.44912 18.6535C8.30939 18.2548 8.27283 17.8161 8.34407 17.3929C8.4153 16.9697 8.59113 16.5809 8.84932 16.2758C9.10751 15.9706 9.43646 15.7628 9.79458 15.6786C10.1527 15.5945 10.5239 15.6377 10.8612 15.8028C11.1986 15.9679 11.4869 16.2476 11.6898 16.6064C11.8926 16.9652 12.0009 17.387 12.0009 17.8185C12.0009 18.3972 11.8064 18.9521 11.4602 19.3613C11.114 19.7705 10.6444 20.0004 10.1547 20.0004ZM10.1547 17.0913C10.033 17.0913 9.91406 17.1339 9.81286 17.2138C9.71166 17.2937 9.63278 17.4073 9.58621 17.5402C9.53963 17.6731 9.52744 17.8193 9.55119 17.9604C9.57493 18.1015 9.63354 18.2311 9.71961 18.3328C9.80567 18.4345 9.91532 18.5038 10.0347 18.5318C10.1541 18.5599 10.2778 18.5455 10.3902 18.4905C10.5027 18.4354 10.5988 18.3422 10.6664 18.2226C10.734 18.103 10.7701 17.9624 10.7701 17.8185C10.7701 17.6257 10.7053 17.4407 10.5899 17.3043C10.4745 17.1679 10.318 17.0913 10.1547 17.0913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3854 12.727H17.5392C17.376 12.727 17.2195 12.6504 17.1041 12.514C16.9887 12.3776 16.9238 12.1926 16.9238 11.9997C16.9238 11.8068 16.9887 11.6219 17.1041 11.4855C17.2195 11.3491 17.376 11.2725 17.5392 11.2725H19.3854C19.5486 11.2725 19.7051 11.3491 19.8205 11.4855C19.9359 11.6219 20.0008 11.8068 20.0008 11.9997C20.0008 12.1926 19.9359 12.3776 19.8205 12.514C19.7051 12.6504 19.5486 12.727 19.3854 12.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3849 18.5454H11.3849C11.2217 18.5454 11.0652 18.4687 10.9498 18.3324C10.8344 18.196 10.7695 18.011 10.7695 17.8181C10.7695 17.6252 10.8344 17.4402 10.9498 17.3038C11.0652 17.1674 11.2217 17.0908 11.3849 17.0908H19.3849C19.5481 17.0908 19.7047 17.1674 19.8201 17.3038C19.9355 17.4402 20.0003 17.6252 20.0003 17.8181C20.0003 18.011 19.9355 18.196 19.8201 18.3324C19.7047 18.4687 19.5481 18.5454 19.3849 18.5454Z",
    fill: "white"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9158_13463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSort);
export default __webpack_public_path__ + "static/media/Filter-Sort.bfffa0e77e8b01c7cc0eb4a212af79e5.svg";
export { ForwardRef as ReactComponent };